import React, { useEffect, useState } from "react";
import { PageQuestionOption } from "../../types/hexpertTypes";
import { SelectButton } from "../Buttons";
import cs from "classnames";
import './StepSlider.scss';

type TStepSlider = {
  steps: PageQuestionOption[]; //@TODO
  onChange?: (value: string) => void;
  name?: string;
  selectedPosition?: number;
  convertUnit?: (unit: string) => string;
};

export const StepSlider = ({
  selectedPosition,
  steps,
  onChange,
  name,
  convertUnit,
}: TStepSlider) => {
  const [position, setPosition] = useState(selectedPosition ?? 0);

  useEffect(() => {
    setPosition(selectedPosition ?? 0);
  }, [selectedPosition]);
  return (
    <div className="c-hex-step-slider-container">
      <input
        type="range"
        value={position}
        className="c-hex-step-slider-input"
        onChange={(e) => {
          // needed for drag
          setPosition(Number(e.target.value));
        }}
        min={0}
        max={(steps?.length ?? 0) - 1}
      />
      <div
        className="c-hex-step-slider-input-thumb"
        style={{
          left: `calc(100% /${(steps?.length ?? 0) * 2} * ${position * 2
            } + 100%/${(steps?.length ?? 0) * 2} - 16px)`,
        }}
      />
      <div className="c-hex-step-slider-input-steps">
        {steps?.map((step, index) => {
          return (
            <div className="c-hex-step-slider-input-step" key={index}>
              <input
                type="radio"
                name={name}
                className="c-hex-step-slider-input-value"
                value={step.Value}
                checked={index === position}
                onChange={() => onChange(step.Value)}
              />
              <div
                className={cs("c-hex-step-slider-input-step-bar", {
                  "c-hex-step-slider-input-step-bar-active": index === position,
                })}
              ></div>
              <p className="c-hex-step-slider-input-step-value">
                {step?.Caption && convertUnit(step?.Caption)}
              </p>
            </div>
          );
        })}
      </div>
      <div className="c-hex-step-slider-input-steps--mobile">
        {steps?.map((step, index) => {
          return (
            <SelectButton
              key={index}
              name={name}
              value={step.Value}
              label={convertUnit(step?.Caption)}
              action={() => onChange(step.Value)}
              selected={selectedPosition === index}
            />
          );
        })}
      </div>
    </div>
  );
};
